import * as Fold from "..";
import * as RA from "fp-ts/ReadonlyArray";
// All our lenses are right associated. Need to reverse each to avoid reversed list
export const _each = () => Fold.fold((fold, empty, s) => {
    const _s = [...s].reverse();
    let b = empty;
    for (const a of _s) {
        b = fold(a, b);
    }
    return b;
});
export const _head = () => Fold.fold((fold, empty, s) => {
    for (const a of s) {
        return fold(a, empty);
    }
    return empty;
});
export const _last = () => Fold.fold((fold, empty, s) => {
    let item = null;
    for (const a of s) {
        item = a;
    }
    return item === null ? empty : fold(item, empty);
});
/**
 * Aggregates all possible values into a list, if there are multiple available in given Fold.
 * Useful when dealing with Fold.alt
 */
export const _all = (f) => Fold.fold((fold, empty, s) => {
    const _s = f.foldr((a, b) => RA.prepend(a)(b), RA.empty, s);
    return fold(_s, empty);
});

